setInterval(function () {
  const buttons = document.querySelectorAll(".single-add-to-cart-button--text");
  for (let i = 0; i < buttons.length; i++) {
    const button = buttons[i];
    const html = button.innerHTML;
    if (html === "Sold out") {
      button.parentNode.classList.add("soldout_button");
    } else {
      button.parentNode.classList.remove("soldout_button");
    }
  }
});
